export default {
    install(Vue, options = {}) {
        const imgClass = options.imgClass || 'new-icon';

        Vue.directive('scroll-top-on-img', {
            inserted(el) {
                const imgs = el.querySelectorAll(`img.${imgClass}`);

                if (!imgs.length) {
                    scrollToTop();
                    return;
                }

                let loadedCount = 0;

                imgs.forEach(img => {
                    // 已缓存图片
                    if (img.complete) {
                        loadedCount++;
                    } else {
                        img.addEventListener('load', onLoad);
                        img.addEventListener('error', onLoad);
                    }
                });

                function onLoad() {
                    loadedCount++;
                    if (loadedCount === imgs.length) {
                        scrollToTop();
                    }
                }

                function scrollToTop() {
                    document.documentElement.scrollTop = 0;
                    document.body.scrollTop = 0;
                }
            }
        });
    }
};
